<template>
  <div
    class="landing-page"
    :style="`background:url(${$root.cdnPath}/images/yy_bg.jpg) no-repeat;
        background-position: top center;
        background-repeat: no-repeat;
        height: 100%;background-color:#160C00;`"
  >
    <div class="container">
      <div class="landing-page-header">
        <img
          width="160"
          :src="`${$root.cdnPath}/images/risingstar-logo.png`"
          alt="rising star"
        >
      </div>
      <div class="landing-page-banner">
        <div class="landing-page-head">
          <h1>
            TRENDYOL <br>
            <span>YÜKSELEN YILDIZLAR</span>
            PROGRAMI
          </h1>
          <div class="cta-wrapper">
            <div class="content-area">
              İşinde yüksek potansiyele sahip yeni iş ortaklarımızı <br>
              Yükselen Yıldızlar Programı'na alıyor, başarılarla dolu parlak bir geleceğe
              hazırlıyoruz.
            </div>
            <a href="https://partner.trendyol.com/onboarding/satici-formu">
              Yeni Satıcı Başvuru Formu
            </a>
          </div>
        </div>
      </div>

      <div class="video-box">
        <div class="gold-button-wrapper">
          <span class="gold-button"> Tanıtım Videosu </span>
        </div>
        <div>
          <iframe
            width="560"
            height="315"
            src="https://www.youtube.com/embed/bLLxR3e9jJk?controls=0"
            allow="accelerometer;
                  autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowfullscreen
            title=""
          />
        </div>
      </div>
      <div class="program-box">
        <div class="gold-button-wrapper">
          <span class="gold-button"> Programa kimleri seçiyoruz? </span>
        </div>

        <div class="program-detail">
          İş ortaklarımızdan aşağıdaki kriterleri sağlayanları programa dahil ediyoruz.
          <ul>
            <li>Canlıya çıkışından 60-90 gün geçmiş olan</li>
            <li>İlk 60 gün net cirosu 40 bin TL'den büyük olan</li>
            <li>Satıcı puanı 9 ve üzerinde olan</li>
            <li>
              Kusurlu, eksik, görselden farklı ürün göndermeyen ve yüksek müşteri şikayeti almayan.
            </li>
          </ul>

          <div class="gold-button-wrapper line-button">
            <span class="gold-button"> Program Detayları </span>
          </div>
          <div class="step-box">
            <div class="step-box-title">
              Programa dahil edilen iş ortakları için başlangıç
            </div>
            <div class="step-wrapper">
              <div
                class="gold-button-wrapper step-button"
                v-for="(step, index) in steps"
                :key="index"
                :class="activeStep === index && 'active-step'"
                @click="activeStep = index"
              >
                <div class="gold-button">
                  {{ index + 1 }}.Ay
                </div>
              </div>
            </div>
          </div>
          <div class="step-info-container">
            <GIcon
              name="alert-circle"
              stroke-width="2px"
              size="16px"
            />
            <div class="step-info">
              Program detayları hakkında bilgi almak için lütfen tıklayınız.
            </div>
          </div>
        </div>
        <div
          class="step-box-detail"
          :style="activeStep === 2 ? lastDetailStyle : detailStyle"
        >
          <div class="step-box-content">
            <div>
              <span class="content-title"> {{ activeStep + 1 }}. Aşama Ödül Tanımlaması </span>
              <ul class="list-box">
                <li
                  v-for="(stepDetail, index) in steps[activeStep].firstBox"
                  :key="index"
                >
                  {{ stepDetail }}
                </li>
              </ul>
            </div>
            <div
              class="middle"
              v-if="steps[activeStep].secondBox"
            >
              <span class="content-title"> {{ activeStep + 1 }}. Aşama Beklentileri </span>
              <ul class="list-box">
                <li
                  v-for="(stepDetail, index) in steps[activeStep].secondBox"
                  :key="index"
                >
                  {{ stepDetail }}
                </li>
              </ul>
            </div>
            <div :class="activeStep === 2 && 'last-step-box'">
              <span>{{ steps[activeStep].thirdBox[0] }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import GIcon from '@webcore/grace/core/GIcon';

export default Vue.extend({
  name: 'RisingStars',
  components: {
    GIcon,
  },
  data() {
    return {
      activeStep: 0,
      detailStyle: `background:url(${this.$root.cdnPath}/images/arrow.png) no-repeat;`,
      lastDetailStyle: `background:url(${this.$root.cdnPath}/images/bg-two.png) no-repeat;`,
      steps: [
        {
          name: 'firstStep',
          firstBox: [
            'Programa özel tasarlanmış eğitim ve canlı yayın',
            'Birebir satıcı danışmanı ve performans takibi hizmeti',
            'Trendyol reklam bakiyesi desteği',
          ],
          secondBox: ['Satıcıya özel verilen ilk ay hedeflerin gerçekleşmesi'],
          thirdBox: ['Performans kontrolü'],
        },
        {
          name: 'secondStep',
          firstBox: [
            "%30'a varan komisyon indirimi",
            'Birebir satıcı danışmanı ve performans takibi hizmeti',
            'Trendyol reklam bakiyesi desteği',
          ],
          secondBox: ['Satıcıya özel verilen ikinci ay hedeflerin gerçekleeşmesi'],
          thirdBox: ['Performans kontrolü'],
        },
        {
          name: 'thirdStep',
          firstBox: [
            "%30'a varan komisyon indirimi",
            'Birebir satıcı danışmanı ve performans takibi hizmeti',
          ],
          thirdBox: ['Performans Kontrolü ve Programı başarıyla bitirmeye hak kazanma'],
        },
      ],
    };
  },
  mounted() {
    // window.dataLayer.push({
    //   event: 'content-view',
    //   'content-name': this.$route.fullPath,
    //   'content-view-name': this.$route.name,
    // });
  },
  methods: {
    // sendGtmData(action) {
    //   window.dataLayer.push({
    //     event: 'GAEvent',
    //     eventCategory: 'Efsane Günler',
    //     eventAction: action,
    //     eventLabel: window.user.supplierId,
    //   });
    // },
  },
});
</script>

<style lang="scss" scoped>
.container {
  max-width: 1366px;
  width: 100%;
  margin-left: auto;
  margin-right: auto;
  color: #ffffff;
}

.landing-page {
  width: 100%;
  height: 100%;
  margin-top: -30px;
  box-sizing: border-box;
  background-color: #271700;
  padding: 50px 32px 150px 32px;

  &-banner {
    z-index: 1;
    display: flex;
    justify-content: center;

    @media only screen and (max-width: 960px) {
      flex-direction: column-reverse;
    }
  }

  &-bg {
    width: 100%;
    img {
      left: 0;
      right: 0;
      top: 70px;
      z-index: 0;
      width: 90%;
      height: auto;
      margin: 0 auto;
      position: absolute;
    }
  }

  .line-button {
    position: relative;
    &:after {
      content: "";
      left: 0;
      right: 0;
      width: 2px;
      height: 40px;
      bottom: -40px;
      margin: 0 auto;
      position: absolute;
      background-color: #fbba24;
    }
  }

  &-head {
    z-index: 1;

    h1 {
      width: 70%;
      font-size: 64px;
      margin: 0 auto;
      text-align: center;
      span {
        color: #f27a1a;
      }
      @media only screen and (max-width: 960px) {
        width: 100%;
        text-align: center;
      }
    }

    .cta-wrapper {
      display: flex;
      flex: 1 1 auto;
      font-size: 30px;
      margin-top: 60px;
      text-align: center;
      align-items: center;
      flex-direction: column;
      justify-content: center;
      .content-area {
        width: 70%;
        margin: 0 auto;
      }

      a {
        color: #ffffff;
        font-size: 18px;
        margin-top: 50px;
        border-radius: 6px;
        padding: 15px 20px;
        text-decoration: none;
        background-color: #f27a1a;
        box-shadow: 12.9px 15.3px 70px 0 rgba(242, 122, 26, 0.45);

        &:hover {
          background-color: #ef6114;
        }
      }
    }
  }
  .video-box {
    display: flex;
    flex: 1 1 auto;
    align-items: center;
    flex-direction: column;
    justify-content: center;
  }

  .gold-button-wrapper {
    padding: 5px;
    border-radius: 15px;
    margin: 100px 0 30px 0;
    border: 2px solid #fbba24;
  }
  .gold-button {
    font-size: 28px;
    padding: 4px 55px;
    border-radius: 10px;
    display: inline-block;
    background: rgb(117, 87, 43);
    background: linear-gradient(
      90deg,
      rgba(117, 87, 43, 1) 0%,
      rgba(251, 186, 36, 1) 68%,
      rgba(117, 87, 43, 1) 100%
    );
  }

  .program {
    &-box {
      display: flex;
      align-items: center;
      flex-direction: column;
      justify-content: center;
    }
    &-detail {
      display: flex;
      font-size: 18px;
      text-align: center;
      align-items: center;
      flex-direction: column;
      ul {
        list-style: none;

        li {
          position: relative;
          &:before {
            content: ">";
            color: #fbba24;
            position: absolute;
            margin-left: -15px;
            display: inline-block;
          }
        }
      }
      .step-box {
        right: 40px;
        width: 480px;
        display: flex;
        margin-top: 30px;
        position: relative;
        align-items: center;
        flex-direction: column;
        justify-content: center;
        border-radius: 15px;
        border: 2px solid #fbba24;
        border-bottom-right-radius: 0;
        border-right: 0;
        &-title {
          right: 0;
          top: -25px;
          padding: 10px;
          position: absolute;
          border-radius: 10px;
          background: #180c00;
          border: 2px solid #fbba24;
        }
        .step-wrapper {
          top: 50px;
          width: 100%;
          display: flex;
          position: relative;
          justify-content: flex-end;
          .step-button {
            margin: 0;
            cursor: pointer;
            background: #180c00;
            border-radius: 50px;
            .gold-button {
              font-size: 20px;
              padding: 30px 22px;
              border-radius: 50px;
            }

            &:not(:last-child) {
              margin-right: 50px;
            }

            &:not(&.active-step) {
              .gold-button {
                background: transparent;
              }
            }
          }
        }
      }

      .step-info-container {
        display: flex;
        padding-top: 70px;
        align-items: center;

        .step-info {
          font-size: 12px;
          margin-left: 5px;
        }
      }
    }
  }
  .step-box {
    &-detail {
      width: 100%;
      display: flex;
      height: 220px;
      margin-top: 30px;
      align-items: center;
      justify-content: center;
      background-color: #160c00 !important;
      background-size: contain !important;
      background-repeat: no-repeat !important;
      background-position: top center !important;
    }
    &-content {
      display: flex;
      align-items: center;
      justify-content: center;

      div {
        width: 170px;
        padding-top: 10px;
        box-sizing: content-box;

        .content-title {
          display: block;
          font-size: 18px;
          padding-bottom: 10px;
        }
        &.middle {
          padding: 0 90px;
        }
        &.last-step-box {
          padding-left: 70px;
        }
      }
      .list-box {
        padding-left: 0;
        list-style: none;

        li {
          position: relative;
          &:before {
            content: ">";
            color: #fbba24;
            position: absolute;
            margin-left: -15px;
            display: inline-block;
          }
        }
      }
    }
  }
}
</style>
